import { render, staticRenderFns } from "./VolunteerProfileStandard.vue?vue&type=template&id=2f6301ec"
import script from "./VolunteerProfileStandard.vue?vue&type=script&lang=ts"
export * from "./VolunteerProfileStandard.vue?vue&type=script&lang=ts"
import style0 from "./VolunteerProfileStandard.vue?vue&type=style&index=0&id=2f6301ec&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports